// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".co-recommendations__section{width:100%}.co-recommendations__section+*{margin-top:48px}.co-recommendations__titles{margin-bottom:24px}.co-recommendations__slider{position:relative}.co-recommendations__slide{width:auto}.co-recommendations__slide:not(:last-child){margin-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
